import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-slate-200">
      <div className="mx-auto max-w-7xl px-6 lg:px-8 py-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-gray-500">
          <p className="text-sm text-gray-500">© {year} Sedra HQ</p>
          <div className="flex items-center gap-6">
            <Link to="/terms-of-service" className="hover:text-gray-700">Terms</Link>
            <Link to="/privacy-policy" className="hover:text-gray-700">Privacy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 